import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { ZustimmungStatusResponse, ZustimmungSavedResponse } from '../models/api.models';

const LABS_PROJECT = 'AbholfachzettelExpress';

@Injectable({ providedIn: 'root' })
export class ZustimmungService {
  private authService = inject(AuthService);

  private getApiUrl(): string {
    const cfg = environment.controlCenter;
    return window.location.hostname === 'localhost'
      ? 'http://localhost:8000'
      : cfg.apiUrl;
  }

  async getStatus(): Promise<ZustimmungStatusResponse> {
    const token = this.authService.getToken();
    const params = new URLSearchParams({
      environment: environment.controlCenter.environmentName,
      labsProject: LABS_PROJECT
    });
    const res = await fetch(`${this.getApiUrl()}/api/zustimmung?${params}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error(`Zustimmung-Check fehlgeschlagen (${res.status})`);
    return res.json();
  }

  async save(): Promise<ZustimmungSavedResponse> {
    const token = this.authService.getToken();
    const res = await fetch(`${this.getApiUrl()}/api/zustimmung`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        environment: environment.controlCenter.environmentName,
        labsProject: LABS_PROJECT
      })
    });
    if (!res.ok) throw new Error(`Zustimmung speichern fehlgeschlagen (${res.status})`);
    return res.json();
  }
}
